import { render, staticRenderFns } from "./_JourneyStatus.vue?vue&type=template&id=2afd5f31"
import script from "./_JourneyStatus.vue?vue&type=script&lang=ts"
export * from "./_JourneyStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports